import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminLogin } from '../firebase/firestoreService';

const Login = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [status, setStatus] = useState('');
  const navigate = useNavigate();

  const handleChange = e => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  const handleSubmit = async e => {
    e.preventDefault();
    setStatus('loading');
    try {
      await adminLogin(form.email, form.password);
      navigate('/admin');
    } catch (err) {
      setStatus('error');
    }
  };

  return (
    <>
      <div className="ngt-page-banner">
        <h1>Admin Login</h1>
        <p>Authorised personnel only</p>
      </div>
      <section style={{ padding: '4rem 0' }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-5">
              <div className="ngt-enquiry-form-wrap">
                <h2 style={{ fontFamily: 'Playfair Display,serif', color: 'var(--ngt-navy)', marginBottom: '1.5rem', textAlign: 'center' }}>
                  Administrator Access
                </h2>
                {status === 'error' && (
                  <div className="ngt-alert-error mb-3">
                    <i className="fas fa-exclamation-circle me-2"></i>
                    Invalid credentials. Please try again.
                  </div>
                )}
                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="ngt-label" htmlFor="adm-email">Email Address</label>
                    <input id="adm-email" name="email" type="email" className="ngt-form-control"
                      value={form.email} onChange={handleChange} required autoComplete="username" />
                  </div>
                  <div className="mb-4">
                    <label className="ngt-label" htmlFor="adm-pass">Password</label>
                    <input id="adm-pass" name="password" type="password" className="ngt-form-control"
                      value={form.password} onChange={handleChange} required autoComplete="current-password" />
                  </div>
                  <button type="submit" className="btn-ngt-primary w-100" style={{ padding: '13px' }}
                    disabled={status === 'loading'}>
                    {status === 'loading'
                      ? <><i className="fas fa-spinner fa-spin me-2"></i>Logging in…</>
                      : <><i className="fas fa-lock me-2"></i>Login</>}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Login;
